module.exports = __webpack_public_path__ + "static/media/NeuzeitGroExtBla.049e8dbe.ttf";